export default __webpack_public_path__ + "static/media/github.bc8a16cd.png";